module.exports = __webpack_public_path__ + "img/49TOP-MISAKI-SML-COLORI-LINO-COLORI-GARZA-PANTALONE-GENIUS-SML-COLORI-LINO-COLORI-GARZA12.95b46e7d.jpg";